<template>
    <div>
        <div class="container">
            <div class="top-header-hold">
                <h3>Projects</h3>
                <div>
                    <div class="plus" @click="routeTo('/dashboard/newproject')">
                        <!-- <div class="plus" @click="routeTo('/dashboard/project-add')"> -->
                        <p>+</p>
                    </div>
                </div>
            </div>

            <div class="circle-container d-none">
    
                <!-- 2. The Inline SVG that handles the curved path geometry -->
                <svg class="curved-text-svg" width="60" height="30" viewBox="0 0 60 30">
                <defs>
                    <!-- The invisible track path that the letters follow (a smooth arc) -->
                    <path id="text-curve" d="M 5,5 Q 30,25 55,5" fill="transparent" />
                </defs>
                
                <text>
                    <!-- startOffset="50%" shifts the center of the string to the center of the arc -->
                    <textPath href="#text-curve" startOffset="50%">
                    HELLO
                    </textPath>
                </text>
                </svg>

            </div>
            <div class="top-navigation">
                <span @click="projectTab = 1" class="" :class="[projectTab == 1 ? 'activeNav' : '']">Projects</span> 
                <span :class="[projectTab == 2 ? 'activeNav' : '']" @click="projectTab = 2">Cooporate Projects</span>
            </div>
            <div class="top-navigation mt-1" v-if="projectTab === 2">
                <!-- <span @click="activeTab = 1" class="" :class="[activeTab == 1 ? 'activeNav' : '']">My Projects</span>  -->
                <span :class="[activeTab == 2 ? 'activeNav' : '']" @click="activeTab = 2">Team Projects</span>  
                <span :class="[activeTab == 3 ? 'activeNav' : '']" @click="activeTab = 3">Available Projects</span>
            </div>

            <div class="">


                <div class="mt-5 d-none">
                    <div class="">
                        <EmptyState :emptyData="emptyDataObject"></EmptyState>
                        <button class="btn shelta-btn" @click="routeTo('/dashboard/newproject')">Create New Project</button>
                    </div>
                </div>

                <div v-if="projectTab === 2">
                    <div v-if="activeTab === 1">
                        <div class="row">
                            <div class="col-md-6">
                                <!-- <div class="product-card" @click="routeTo('/dashboard/details-project')"> -->
                                    <div class="product-card" data-toggle="modal" data-target="#projectdetails">
                                    <!-- Image Header Section Container -->
                                    <div class="card-image-section">
                                    <img 
                                        src="../../assets/images/prop1.svg" 
                                        alt="Solar Homes Installations" 
                                        class="main-banner-image"
                                    />
                                    <!-- Category Badge Pill -->
                                    <div class="category-badge">
                                        <!-- <span class="electricity-icon">⚡</span> -->
                                        <span class="category-text">Electricity</span>
                                    </div>
                                    
                                    <!-- Slider Carousel Indicator Dots -->
                                    <div class="carousel-dots">
                                        <span class="dot active"></span>
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                    </div>
                                    </div>

                                    <!-- Title and Status Container Grid Row -->
                                    <div class="card-title-row">
                                    <div class="title-left">
                                        <span class="blue-indicator-dot"></span>
                                        <h2 class="card-main-title">Solar Homes Installations</h2>
                                    </div>
                                    <div class="status-badge-active">Active</div>
                                    </div>

                                    <!-- Financial Breakdown Row Elements -->
                                    <div class="financial-row">
                                    <div class="primary-total-price">₦1,200,000</div>
                                    <div class="monthly-breakdown-pill">₦100,000 / Monthly</div>
                                    </div>

                                    <!-- Dynamic Progress Percentage Bar Wrapper -->
                                    <div class="progress-bar-container">
                                    <div class="progress-track-bg">
                                        <div class="progress-fill-active" :style="{ width: progressPercentage + '%' }"></div>
                                    </div>
                                    <span class="progress-text-label">{{ progressPercentage }}%</span>
                                    </div>

                                    <!-- Progress Target Bounds Info Footnote Row -->
                                    <div class="progress-bounds-row">
                                    <div class="bound-min">₦100,000</div>
                                    <div class="bound-max">₦1,200,000</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="product-card" @click="openPojectDetails(details)">
                                    <!-- Image Header Section Container -->
                                    <div class="card-image-section">
                                    <img 
                                        src="../../assets/images/prop1.svg" 
                                        alt="Solar Homes Installations" 
                                        class="main-banner-image"
                                    />
                                    <!-- Category Badge Pill -->
                                    <div class="category-badge">
                                        <!-- <span class="electricity-icon">⚡</span> -->
                                        <span class="category-text">Electricity</span>
                                    </div>
                                    
                                    <!-- Slider Carousel Indicator Dots -->
                                    <div class="carousel-dots">
                                        <span class="dot active"></span>
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                    </div>
                                    </div>

                                    <!-- Title and Status Container Grid Row -->
                                    <div class="card-title-row">
                                    <div class="title-left">
                                        <span class="blue-indicator-dot"></span>
                                        <h2 class="card-main-title">Solar Homes Installations</h2>
                                    </div>
                                    <div class="status-badge-active">Active</div>
                                    </div>

                                    <!-- Financial Breakdown Row Elements -->
                                    <div class="financial-row">
                                    <div class="primary-total-price">₦1,200,000</div>
                                    <div class="monthly-breakdown-pill">₦100,000 / Monthly</div>
                                    </div>

                                    <!-- Dynamic Progress Percentage Bar Wrapper -->
                                    <div class="progress-bar-container">
                                    <div class="progress-track-bg">
                                        <div class="progress-fill-active" :style="{ width: progressPercentage + '%' }"></div>
                                    </div>
                                    <span class="progress-text-label">{{ progressPercentage }}%</span>
                                    </div>

                                    <!-- Progress Target Bounds Info Footnote Row -->
                                    <div class="progress-bounds-row">
                                    <div class="bound-min">₦100,000</div>
                                    <div class="bound-max">₦1,200,000</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="product-card">
                                    <!-- Image Header Section Container -->
                                    <div class="card-image-section">
                                    <img 
                                        src="../../assets/images/prop1.svg" 
                                        alt="Solar Homes Installations" 
                                        class="main-banner-image"
                                    />
                                    <!-- Category Badge Pill -->
                                    <div class="category-badge">
                                        <!-- <span class="electricity-icon">⚡</span> -->
                                        <span class="category-text">Electricity</span>
                                    </div>
                                    
                                    <!-- Slider Carousel Indicator Dots -->
                                    <div class="carousel-dots">
                                        <span class="dot active"></span>
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                    </div>
                                    </div>

                                    <!-- Title and Status Container Grid Row -->
                                    <div class="card-title-row">
                                    <div class="title-left">
                                        <span class="blue-indicator-dot"></span>
                                        <h2 class="card-main-title">Solar Homes Installations</h2>
                                    </div>
                                    <div class="status-badge-active">Active</div>
                                    </div>

                                    <!-- Financial Breakdown Row Elements -->
                                    <div class="financial-row">
                                    <div class="primary-total-price">₦1,200,000</div>
                                    <div class="monthly-breakdown-pill">₦100,000 / Monthly</div>
                                    </div>

                                    <!-- Dynamic Progress Percentage Bar Wrapper -->
                                    <div class="progress-bar-container">
                                    <div class="progress-track-bg">
                                        <div class="progress-fill-active" :style="{ width: progressPercentage + '%' }"></div>
                                    </div>
                                    <span class="progress-text-label">{{ progressPercentage }}%</span>
                                    </div>

                                    <!-- Progress Target Bounds Info Footnote Row -->
                                    <div class="progress-bounds-row">
                                    <div class="bound-min">₦100,000</div>
                                    <div class="bound-max">₦1,200,000</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="product-card">
                                    <!-- Image Header Section Container -->
                                    <div class="card-image-section">
                                    <img 
                                        src="../../assets/images/prop1.svg" 
                                        alt="Solar Homes Installations" 
                                        class="main-banner-image"
                                    />
                                    <!-- Category Badge Pill -->
                                    <div class="category-badge">
                                        <!-- <span class="electricity-icon">⚡</span> -->
                                        <span class="category-text">Electricity</span>
                                    </div>
                                    
                                    <!-- Slider Carousel Indicator Dots -->
                                    <div class="carousel-dots">
                                        <span class="dot active"></span>
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                        <span class="dot"></span>
                                    </div>
                                    </div>

                                    <!-- Title and Status Container Grid Row -->
                                    <div class="card-title-row">
                                    <div class="title-left">
                                        <span class="blue-indicator-dot"></span>
                                        <h2 class="card-main-title">Solar Homes Installations</h2>
                                    </div>
                                    <div class="status-badge-active">Active</div>
                                    </div>

                                    <!-- Financial Breakdown Row Elements -->
                                    <div class="financial-row">
                                    <div class="primary-total-price">₦1,200,000</div>
                                    <div class="monthly-breakdown-pill">₦100,000 / Monthly</div>
                                    </div>

                                    <!-- Dynamic Progress Percentage Bar Wrapper -->
                                    <div class="progress-bar-container">
                                    <div class="progress-track-bg">
                                        <div class="progress-fill-active" :style="{ width: progressPercentage + '%' }"></div>
                                    </div>
                                    <span class="progress-text-label">{{ progressPercentage }}%</span>
                                    </div>

                                    <!-- Progress Target Bounds Info Footnote Row -->
                                    <div class="progress-bounds-row">
                                    <div class="bound-min">₦100,000</div>
                                    <div class="bound-max">₦1,200,000</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="activeTab === 2">
                        <div class="row">
                            <div class="col-md-4" v-for="(item, index) in teamProjects" :key="index">
                                <!-- <div class="product-card" @click="routeTo('/dashboard/details-project')"> -->
                                    <div class="product-card" @click="openPojectDetails3(item)">
                                        <!-- Image Header Section Container -->
                                        <div class="card-image-section">
                                            <img v-if="item.image_url != null" 
                                                :src="item.image_url" 
                                                alt="Solar Homes Installations" 
                                                class="main-banner-image"
                                            />
                                            <img v-else
                                                src="../../assets/images/prop1.svg" 
                                                alt="Solar Homes Installations" 
                                                class="main-banner-image"
                                            />
                                            <!-- Category Badge Pill -->
                                            <div class="category-badge">
                                                <!-- <span class="electricity-icon">⚡</span> -->
                                                <span class="category-text">{{item.corporate_project.category}}</span>
                                            </div>
                                            
                                        </div>

                                    <!-- Title and Status Container Grid Row -->
                                    <div class="card-title-row mb-0">
                                        <div class="title-left">
                                            <span class="blue-indicator-dot"></span>
                                            <h2 class="card-main-title">{{item.corporate_project.title}}</h2>
                                            
                                        </div>
                                    
                                    </div>
                                    <hr>

                                    <!-- Financial Breakdown Row Elements -->
                                    <div class="financial-row">
                                        <div class="primary-total-price">₦{{Number(item.actual_equity_contribution_value).toLocaleString()}}</div>
                                        <div class="monthly-breakdown-pill">{{ item.payment_frequency }}</div>
                                    </div>


                                    <div class="progress-bounds-row">
                                        <div class="bound-min">Duration</div>
                                        <div class="bound-max">{{ item.corporate_project.start_date | moment2 }} - {{ item.corporate_project.end_date | moment2 }}</div>
                                    </div>

                                    <div class="slots-left">
                                        <div class="text-slot">Open Slot - {{ item.corporate_project.available_units }} Left</div>
                                        <div><i class="fa fa-chevron-right"></i></div>
                                    </div>
                                </div>
                            </div>

                            <div class="m-auto" v-if="teamProjects.length == 0">
                                <EmptyState :emptyData="emptyDataObject2"></EmptyState>
                                <!-- <button class="btn shelta-btn" @click="routeTo('/dashboard/newproject')">Create New Project</button> -->
                            </div>
                            
                        </div>
                    </div>
                    <div v-if="activeTab === 3">
                        <div class="row">
                            <div class="col-md-4"  v-for="(item, index) in avaliableProjects" :key="index">
                                <!-- <div class="product-card" @click="routeTo('/dashboard/details-project')"> -->
                                    <div class="product-card" @click="openPojectDetails3(item)">
                                        <!-- Image Header Section Container -->
                                        <div class="card-image-section">
                                            <img v-if="item.image_url != null" 
                                                :src="item.image_url" 
                                                alt="Solar Homes Installations" 
                                                class="main-banner-image"
                                            />
                                            <img v-else
                                                src="../../assets/images/prop1.svg" 
                                                alt="Solar Homes Installations" 
                                                class="main-banner-image"
                                            />
                                            <!-- Category Badge Pill -->
                                            <div class="category-badge">
                                                <!-- <span class="electricity-icon">⚡</span> -->
                                                <span class="category-text">{{item.corporate_project.category}}</span>
                                            </div>
                                            
                                        </div>

                                    <!-- Title and Status Container Grid Row -->
                                    <div class="card-title-row mb-0">
                                        <div class="title-left">
                                            <span class="blue-indicator-dot"></span>
                                            <h2 class="card-main-title">{{ item.corporate_project.title }}</h2>
                                            
                                        </div>
                                    
                                    </div>
                                    <hr>

                                    <!-- Financial Breakdown Row Elements -->
                                    <div class="financial-row">
                                        <div class="primary-total-price">₦{{Number(item.actual_equity_contribution_value).toLocaleString()}}</div>
                                        <div class="monthly-breakdown-pill">{{ item.payment_frequency }}</div>
                                    </div>


                                    <div class="progress-bounds-row">
                                        <div class="bound-min">Duration</div>
                                        <div class="bound-max">{{ item.corporate_project.start_date | moment2 }} - {{ item.corporate_project.end_date | moment2 }}</div>
                                    </div>

                                    <div class="slots-left">
                                        <div class="text-slot">Open Slot - {{ item.corporate_project.available_units }} Left</div>
                                        <div><i class="fa fa-chevron-right"></i></div>
                                    </div>
                                </div>
                            </div>
                            <div class="m-auto" v-if="avaliableProjects.length == 0">
                                <EmptyState :emptyData="emptyDataObject3"></EmptyState>
                                <!-- <button class="btn shelta-btn" @click="routeTo('/dashboard/newproject')">Create New Project</button> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="projectTab === 1">
                    <SafeProject></SafeProject>
                </div>
                <ProjectDetailsModal v-if="projectModalData !== null"  :projectData="projectModalData"></ProjectDetailsModal>
                <FundProjectModal></FundProjectModal>
                <AvailableProjectDetailsModal v-if="projectModalData !== null"  :projectData="projectModalData"></AvailableProjectDetailsModal>
            </div>
        </div>
    </div>
</template>


<script>
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
import EmptyState from "../../components/EmptyState.vue";
import ProjectDetailsModal from "../../components/CooporativeProjects/ProjectDetailsModal.vue";
import AvailableProjectDetailsModal from "../../components/CooporativeProjects/AvailableProjectDetailsModal.vue";
import FundProjectModal from "../../components/CooporativeProjects/FundProjectModal.vue";
import SafeProject from "../../components/SafeProjects.vue";
import moment from "moment";
import $ from "jquery";
export default {
    name: "ProjectHome",
    components: {
        PageLoader,
        EmptyState,
        ProjectDetailsModal,
        FundProjectModal,
        AvailableProjectDetailsModal,
        SafeProject
    },

    data() {
        return {
            activeTab: 2,
            projectTab: 1,
            progressPercentage: 50,
            projectModalData: null,
            teamProjects: [],
            avaliableProjects: [],
            // teamProjectsCooporateProjects: "",
            // teamProjectsCooporate: "",
            details: {
                name: "ayo",
                age: 35
            },
            emptyDataObject: {
                header: "You haven't created any project yet",
                option: "Start by creating a project or join an available project that interests you."
            },
            emptyDataObject2: {
                header: "No team project created yet",
                option: "Team project will be available when created."
            },
            emptyDataObject3: {
                header: "No available project created yet",
                option: "Available project will be displayed when created."
            },
        };
    },
    created() {

    },
    mounted() {
        this.fetchTeamProject();
        this.fetchAvailableProject();
    },
    methods: {
        routeTo(route) {
            this.$router
            .push({
            path: `${route}`
            })
            .catch(() => {
            // console.log("none")
            });
        },
        openPojectDetails(details) {
            console.log("Details check", details)
            $("#projectdetails")
            .addClass("fade")
            .modal("show");
            this.projectModalData = { ...details };
        },

        openPojectDetails3(details) {
            console.log("Details check3", details)
            $("#availableprojectdetails")
            .addClass("fade")
            .modal("show");
            this.projectModalData = { ...details };
        },
        async fetchTeamProject() {
            this.loading = true;
            try {
                await Api.getRequest(`fetch-user-corporate-team-projects`).then(res => {
                    this.loading = false;
                    console.log("Team projects", res);
                    if (res.data.success) {
                        this.teamProjects = res.data.projects;
                        // this.teamProjectsCooporate = res.data.projects.cooporate;
                        // this.teamProjectsCooporateProjects = res.data.projects.cooporate_project;
                    }
                    if (res.data.error) {
                        return this.$store.commit("setApiFailed", res.data.error);
                    }
                }).catch(err => {
                    console.log("error:", err)
                    this.loading = false;
                })
            } finally {
                // console.log("closed");
            }
        },
        async fetchAvailableProject() {
            this.loading = true;
            try {
                await Api.getRequest(`fetch-user-corporate-available-projects`).then(res => {
                    this.loading = false;
                    console.log("Available projects", res);
                    if (res.data.success) {
                        this.avaliableProjects = res.data.projects;
                        // this.teamProjectsCooporate = res.data.projects.cooporate;
                        // this.teamProjectsCooporateProjects = res.data.projects.cooporate_project;
                    }
                    if (res.data.error) {
                        return this.$store.commit("setApiFailed", res.data.error);
                    }
                }).catch(err => {
                    console.log("error:", err)
                    this.loading = false;
                })
            } finally {
                // console.log("closed");
            }
        }

        
    },
    filters: {
        moment: function(date) {
            return moment(date).format("MMMM Do YYYY, h:mm:ss a");
        },
        moment2: function(date) {
            return moment(date).format("MMMM Do YYYY");
        }
    }
};
</script>



<style scoped lang="scss">
.top-header-hold {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
    h3 {
        font-family: Lato;
        font-weight: 600;
        font-size: 18px;
        line-height: 26px;
        color: #1A1A1A;
        text-align: center;
    }
    .plus {
        background: #0033EA;
        color: #ffffff;
        border-radius: 50px;
        padding: 22px;
        width: 30px;
        height: 30px;
        position: relative;
        cursor: pointer;
        p {
            position: absolute;
            left: 12px;
            top: -3px;
            font-size: 32px;
        }
    }
    .plus:hover {
        background: #01155c;
        width: 34px;
        height: 34px;
    }
}
.top-navigation {
    background: #ffffff;
    // height: 50px;
    padding: 20px;
    border-radius: 4px;
    display: flex;
    overflow: scroll;
    margin-top: 50px;
    span {
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        text-align: center;
        margin-right: 20px;
        cursor: pointer;
        padding: 5px;
    }
}
.activeNav {
    border-bottom: 3px solid #0033EA;
    // border-width: inherit;
}

.shelta-btn {
    background: #0033EA;
    color: #ffffff;
    font-family: Lato;
    font-weight: 500;
    font-size: 14px;
    text-align: center;
    margin-bottom: 20px;
    outline: 0;
    box-shadow: none;
}

.product-card {
  width: 100%;
//   max-width: 440px;
  max-width: 540px;
  background-color: #ffffff;
  border-radius: 24px;
  padding: 24px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.03); /* Soft, ambient all-round shadow */
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  box-sizing: border-box;
  margin: 16px auto;
  cursor: pointer;
}

/* Image Wrapper Positioning Layout */
.card-image-section {
  position: relative;
  width: 100%;
//   height: 200px;
  height: 250px;
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 24px;
  background-color: #f3f4f6;
}

.main-banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center; 
}

/* Electricity Floating Tag Pillar Component */
.category-badge {
  position: absolute;
  top: 16px;
  left: 16px;
  background-color: #ffffff;
  padding: 4px 16px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.electricity-icon {
  color: #f59e0b; /* Golden Amber Energy icon color match */
  font-size: 14px;
}

.category-text {
  color: #b45309;
  font-weight: 500;
  font-size: 13px;
  font-family: Lato;
}

/* Slider Pagination Circle Indicators overlay layer style */
.carousel-dots {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 6px;
}

.dot {
  width: 6px;
  height: 6px;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 50%;
}

.dot.active {
  background-color: #ffffff;
  width: 12px; /* Active dot is stretched in image */
  border-radius: 4px;
}

/* Header Grid Row & Badging Element Styling rules */
.card-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.title-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.blue-indicator-dot {
  width: 10px;
  height: 10px;
  background-color: #2563eb; /* Deep primary icon blue color standard marker */
  border-radius: 50%;
  flex-shrink: 0;
}



.card-main-title {
    // font-size: 20px;
    font-weight: 700;
    color: #1A1A1A;
    margin: 0;
    font-family: Lato;
    font-size: 16px;
    line-height: 24px;
    text-align: left;

    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;  
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word; 
}

.status-badge-active {
  border: 1px solid #3b82f6;
  color: #0033EA;
  padding: 6px 16px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  font-family: Lato;
}

/* Financial values alignment layout settings grid */
.financial-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.primary-total-price {
    // font-size: 24px;
    // font-weight: 800;
    color: #1A1A1A;
    font-family: Lato;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    text-align: left;

}

.monthly-breakdown-pill {
    background-color: #eff6ff;
    color: #0033EA;
    padding: 8px 14px;
    border-radius: 50px;
    font-size: 12px;
    font-family: Lato;
    font-weight: 600;
    line-height: 24px;
    text-align: center;

}

/* Tracking Bar layout grid container rule sets */
.progress-bar-container {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.progress-track-bg {
  flex: 1;
  height: 10px;
  background-color: #f3f4f6;
  border-radius: 5px;
  overflow: hidden;
}

.progress-fill-active {
  height: 100%;
  background: linear-gradient(90deg, #3b82f6, #1d4ed8); /* High contrast matching blue gradient track filling style */
  border-radius: 5px;
}

.progress-text-label {
  font-size: 14px;
  font-weight: 600;
  color: #1e3a8a;
  min-width: 32px;
  font-family: Lato;
}

/* Footnote bounds row structural definitions */
.progress-bounds-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 500;
  color: #4b5563;
}

.bound-min, .bound-max {
    font-family: Lato;
    font-weight: 500;
    font-size: 13px;
    line-height: 24px;
    color: #555555;
}

.slots-left {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    i {
        font-size: 13px;
    }
    .text-slot {
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        text-align: left;
        color: #4688F4;
    }
}




// .circle-container {
//       width: 20px;
//       height: 20px;
//       background-color: #007bff;
//       border-radius: 50%;
//       position: relative;
//       /* Allows you to center items if needed */
//       display: flex;
//       align-items: center;
//       justify-content: center;
//     }

//     /* Position the curved text element right underneath the 20px div */
//     .curved-text-svg {
//       position: absolute;
//       top: 18px; /* Adjust this to move the curve closer or further down */
//       left: 50%;
//       transform: translateX(-50%);
//       overflow: visible; /* Prevents text from clipping */
//     }

//     /* Style the text inside the SVG */
//     .curved-text-svg text {
//       font-family: Arial, sans-serif;
//       font-size: 6px; /* Small font size scaled to look good below a 20px div */
//       fill: #333333;  /* Text color */
//       text-anchor: middle; /* Ensures text is perfectly centered on the curve */
//     }

</style>